import http from "../lib/http";

/**
 * Track recently viewed product
 */
export const trackProductView = (productId) => {
  if (!productId) return Promise.resolve();

  return http.post(`/api/customer/products/${productId}/view`, {
    product_id: productId,
  });
};

/**
 * Get recently viewed products
 */
export const getRecentlyViewed = () => {
  return http.get("/api/customer/recently-viewed");
};